export function isValidInternalPath(path?: string | null): path is string {
  return !!path && path.startsWith('/') && !path.startsWith('//');
}

export function getPostLoginRedirect(search: string): string | undefined {
  const params = new URLSearchParams(search);
  const redirect = params.get('redirect');
  return isValidInternalPath(redirect) ? redirect : undefined;
}
